import * as React from "react";
function SvgTable(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={4}
        d="M2 2h28v28H2zm0 10h28m-18 0v18"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTable);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
